import { SmallIcon } from '@joor/design-system'
import styled from 'styled-components/macro'

import { OrdersTableIds } from '../joorPayOrders.ids'

export function ActionCell({ disabled }: { disabled: boolean }) {
  return (
    <Container
      data-testid={ActionCellTestIds.Container}
      className={disabled ? 'disabled' : ''}
      id={OrdersTableIds.ActionsMenu}
    >
      {disabled ? (
        <SmallIcon
          iconName="no"
          plain
          data-testid={ActionCellTestIds.DisabledIcon}
        />
      ) : (
        <SmallIcon
          iconName="ellipses"
          data-testid={ActionCellTestIds.EnabledIcon}
        />
      )}
    </Container>
  )
}

export const ActionCellTestIds = {
  Container: 'action-cell-container',
  DisabledIcon: 'action-cell-disabled-icon',
  EnabledIcon: 'action-cell-enabled-icon',
} as const

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &.disabled {
    &:hover {
      cursor: not-allowed;
    }
  }
`
